module.exports = __webpack_public_path__ + "img/outline-icons.82f60bd0.b551b554.svg";